export function md5(inputString: string): string {
    const hexCharacters = "0123456789abcdef";

    const inputBlocks = stringToBlocks(inputString);
    let a = 1_732_584_193,
        b = -271_733_879,
        c = -1_732_584_194,
        d = 271_733_878;

    for (let index = 0; index < inputBlocks.length; index += 16) {
        const oldA = a,
            oldB = b,
            oldC = c,
            oldD = d;

        a = fFunction(a, b, c, d, inputBlocks[index + 0], 7, -680_876_936);
        d = fFunction(d, a, b, c, inputBlocks[index + 1], 12, -389_564_586);
        c = fFunction(c, d, a, b, inputBlocks[index + 2], 17, 606_105_819);
        b = fFunction(b, c, d, a, inputBlocks[index + 3], 22, -1_044_525_330);
        a = fFunction(a, b, c, d, inputBlocks[index + 4], 7, -176_418_897);
        d = fFunction(d, a, b, c, inputBlocks[index + 5], 12, 1_200_080_426);
        c = fFunction(c, d, a, b, inputBlocks[index + 6], 17, -1_473_231_341);
        b = fFunction(b, c, d, a, inputBlocks[index + 7], 22, -45_705_983);
        a = fFunction(a, b, c, d, inputBlocks[index + 8], 7, 1_770_035_416);
        d = fFunction(d, a, b, c, inputBlocks[index + 9], 12, -1_958_414_417);
        c = fFunction(c, d, a, b, inputBlocks[index + 10], 17, -42_063);
        b = fFunction(b, c, d, a, inputBlocks[index + 11], 22, -1_990_404_162);
        a = fFunction(a, b, c, d, inputBlocks[index + 12], 7, 1_804_603_682);
        d = fFunction(d, a, b, c, inputBlocks[index + 13], 12, -40_341_101);
        c = fFunction(c, d, a, b, inputBlocks[index + 14], 17, -1_502_002_290);
        b = fFunction(b, c, d, a, inputBlocks[index + 15], 22, 1_236_535_329);

        a = gFunction(a, b, c, d, inputBlocks[index + 1], 5, -165_796_510);
        d = gFunction(d, a, b, c, inputBlocks[index + 6], 9, -1_069_501_632);
        c = gFunction(c, d, a, b, inputBlocks[index + 11], 14, 643_717_713);
        b = gFunction(b, c, d, a, inputBlocks[index + 0], 20, -373_897_302);
        a = gFunction(a, b, c, d, inputBlocks[index + 5], 5, -701_558_691);
        d = gFunction(d, a, b, c, inputBlocks[index + 10], 9, 38_016_083);
        c = gFunction(c, d, a, b, inputBlocks[index + 15], 14, -660_478_335);
        b = gFunction(b, c, d, a, inputBlocks[index + 4], 20, -405_537_848);
        a = gFunction(a, b, c, d, inputBlocks[index + 9], 5, 568_446_438);
        d = gFunction(d, a, b, c, inputBlocks[index + 14], 9, -1_019_803_690);
        c = gFunction(c, d, a, b, inputBlocks[index + 3], 14, -187_363_961);
        b = gFunction(b, c, d, a, inputBlocks[index + 8], 20, 1_163_531_501);
        a = gFunction(a, b, c, d, inputBlocks[index + 13], 5, -1_444_681_467);
        d = gFunction(d, a, b, c, inputBlocks[index + 2], 9, -51_403_784);
        c = gFunction(c, d, a, b, inputBlocks[index + 7], 14, 1_735_328_473);
        b = gFunction(b, c, d, a, inputBlocks[index + 12], 20, -1_926_607_734);

        a = hFunction(a, b, c, d, inputBlocks[index + 5], 4, -378_558);
        d = hFunction(d, a, b, c, inputBlocks[index + 8], 11, -2_022_574_463);
        c = hFunction(c, d, a, b, inputBlocks[index + 11], 16, 1_839_030_562);
        b = hFunction(b, c, d, a, inputBlocks[index + 14], 23, -35_309_556);
        a = hFunction(a, b, c, d, inputBlocks[index + 1], 4, -1_530_992_060);
        d = hFunction(d, a, b, c, inputBlocks[index + 4], 11, 1_272_893_353);
        c = hFunction(c, d, a, b, inputBlocks[index + 7], 16, -155_497_632);
        b = hFunction(b, c, d, a, inputBlocks[index + 10], 23, -1_094_730_640);
        a = hFunction(a, b, c, d, inputBlocks[index + 13], 4, 681_279_174);
        d = hFunction(d, a, b, c, inputBlocks[index + 0], 11, -358_537_222);
        c = hFunction(c, d, a, b, inputBlocks[index + 3], 16, -722_521_979);
        b = hFunction(b, c, d, a, inputBlocks[index + 6], 23, 76_029_189);
        a = hFunction(a, b, c, d, inputBlocks[index + 9], 4, -640_364_487);
        d = hFunction(d, a, b, c, inputBlocks[index + 12], 11, -421_815_835);
        c = hFunction(c, d, a, b, inputBlocks[index + 15], 16, 530_742_520);
        b = hFunction(b, c, d, a, inputBlocks[index + 2], 23, -995_338_651);

        a = indexFunction(a, b, c, d, inputBlocks[index + 0], 6, -198_630_844);
        d = indexFunction(
            d,
            a,
            b,
            c,
            inputBlocks[index + 7],
            10,
            1_126_891_415,
        );
        c = indexFunction(
            c,
            d,
            a,
            b,
            inputBlocks[index + 14],
            15,
            -1_416_354_905,
        );
        b = indexFunction(b, c, d, a, inputBlocks[index + 5], 21, -57_434_055);
        a = indexFunction(
            a,
            b,
            c,
            d,
            inputBlocks[index + 12],
            6,
            1_700_485_571,
        );
        d = indexFunction(
            d,
            a,
            b,
            c,
            inputBlocks[index + 3],
            10,
            -1_894_986_606,
        );
        c = indexFunction(c, d, a, b, inputBlocks[index + 10], 15, -1_051_523);
        b = indexFunction(
            b,
            c,
            d,
            a,
            inputBlocks[index + 1],
            21,
            -2_054_922_799,
        );
        a = indexFunction(a, b, c, d, inputBlocks[index + 8], 6, 1_873_313_359);
        d = indexFunction(d, a, b, c, inputBlocks[index + 15], 10, -30_611_744);
        c = indexFunction(
            c,
            d,
            a,
            b,
            inputBlocks[index + 6],
            15,
            -1_560_198_380,
        );
        b = indexFunction(
            b,
            c,
            d,
            a,
            inputBlocks[index + 13],
            21,
            1_309_151_649,
        );
        a = indexFunction(a, b, c, d, inputBlocks[index + 4], 6, -145_523_070);
        d = indexFunction(
            d,
            a,
            b,
            c,
            inputBlocks[index + 11],
            10,
            -1_120_210_379,
        );
        c = indexFunction(c, d, a, b, inputBlocks[index + 2], 15, 718_787_259);
        b = indexFunction(b, c, d, a, inputBlocks[index + 9], 21, -343_485_551);

        a = addUnsigned(a, oldA);
        b = addUnsigned(b, oldB);
        c = addUnsigned(c, oldC);
        d = addUnsigned(d, oldD);
    }

    return (
        toHexString(a, hexCharacters) +
        toHexString(b, hexCharacters) +
        toHexString(c, hexCharacters) +
        toHexString(d, hexCharacters)
    );
}

export async function md5sum(text: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    const hashBuffer = await crypto.subtle.digest("MD5", data);
    const hashArray = [...new Uint8Array(hashBuffer)];

    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

function addUnsigned(x: number, y: number): number {
    const low = (x & 0xff_ff) + (y & 0xff_ff);
    const high = (x >> 16) + (y >> 16) + (low >> 16);

    return (high << 16) | (low & 0xff_ff);
}

function combineFunctions(
    q: number,
    a: number,
    b: number,
    x: number,
    s: number,
    t: number,
): number {
    return addUnsigned(
        rotateLeft(addUnsigned(addUnsigned(a, q), addUnsigned(x, t)), s),
        b,
    );
}

function fFunction(
    a: number,
    b: number,
    c: number,
    d: number,
    x: number,
    s: number,
    t: number,
): number {
    return combineFunctions((b & c) | (~b & d), a, b, x, s, t);
}

function gFunction(
    a: number,
    b: number,
    c: number,
    d: number,
    x: number,
    s: number,
    t: number,
): number {
    return combineFunctions((b & d) | (c & ~d), a, b, x, s, t);
}

function hFunction(
    a: number,
    b: number,
    c: number,
    d: number,
    x: number,
    s: number,
    t: number,
): number {
    return combineFunctions(b ^ c ^ d, a, b, x, s, t);
}

function indexFunction(
    a: number,
    b: number,
    c: number,
    d: number,
    x: number,
    s: number,
    t: number,
): number {
    return combineFunctions(c ^ (b | ~d), a, b, x, s, t);
}

function rotateLeft(n: number, bits: number): number {
    return (n << bits) | (n >>> (32 - bits));
}

function stringToBlocks(input: string): number[] {
    const blocksCount = ((input.length + 8) >> 6) + 1;
    const blocks = Array.from<number>({ length: blocksCount * 16 }).fill(0);

    for (let index = 0; index < input.length; index++) {
        // eslint-disable-next-line unicorn/prefer-code-point
        blocks[index >> 2] |= input.charCodeAt(index) << ((index % 4) * 8);
    }

    blocks[input.length >> 2] |= 0x80 << ((input.length % 4) * 8);
    blocks[blocksCount * 16 - 2] = input.length * 8;

    return blocks;
}

function toHexString(number_: number, hexCharacters: string): string {
    let hexString = "";

    for (let index = 0; index <= 3; index++) {
        hexString +=
            hexCharacters.charAt((number_ >> (index * 8 + 4)) & 0x0f) +
            hexCharacters.charAt((number_ >> (index * 8)) & 0x0f);
    }

    return hexString;
}
